import React, { memo, useCallback, useEffect } from 'react'
import { Menu, Badge, Skeleton, Button } from 'antd'
import { HStack } from '../../../../../ui/Stack'
import './index.css'
import { useSelector } from 'react-redux'
import { getChatAvito } from '../../../../../store/chat_avito/action-creators'
import {
    getActiveAvitoChat,
    getActiveAvitoChatId,
    selectChatAvitoData,
    selectChatAvitoError,
    selectChatAvitoIsLoading
} from '../../selectors'
import { ReplyBox } from '../../../../../ui/ReplyBox'
import { BadgeBox, ChatBox } from './styles'
import { IHrChats } from './types'
import { useEventSource } from '../../../../../hooks/useEventSource/useEventSource'
import { addChatAvitoData, setActiveAvitoChatId } from '../../../../../store/chat_avito/actions'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import {MessageBox} from "../../../../../ui/MessageBox";
import { useAppDispatch } from '../../../../../hooks/useAppDispatch/useAppDispatch'
import { MetaBox } from '../../../../../pages_v2/orders/card/ui/tabs/tab-chats/styles'
import { LinkOutlined, MessageOutlined } from '@ant-design/icons'
import { useAvitoChatDeepLink } from '../../../../../hooks/useAvitoChatDeepLink/useAvitoChatDeepLink'

dayjs.extend(utc)

export const HrChats: React.FC<IHrChats> = memo((props: IHrChats) => {
  const { id } = props
  const dispatch = useAppDispatch()
  const chats = useSelector(selectChatAvitoData)
  const isLoading = useSelector(selectChatAvitoIsLoading)
  const error = useSelector(selectChatAvitoError)
  const activeChatId = useSelector(getActiveAvitoChatId)
  const activeChatData = useSelector(getActiveAvitoChat)
  const { sse, subscribe } = useEventSource()
  const { requestedChatId, setRequestedChat } = useAvitoChatDeepLink()

  useEffect(() => {
    let mounted = true
    if (mounted) {
      dispatch(getChatAvito(id, 'hr', requestedChatId))
      subscribe(`/api/avito/live/chat/hr/${id}`, data => {
        dispatch(addChatAvitoData(data))
      })
    }
    return () => {
      mounted = false
      sse?.current?.close()
    }
  }, [id, dispatch, requestedChatId])

  const changeChatHandler = useCallback((chat) => {
    if (chat.key === activeChatId) {
      return
    }
    dispatch(setActiveAvitoChatId(chat.key))
    setRequestedChat(chat.key)
  }, [activeChatId, dispatch, setRequestedChat])


  if (isLoading) {
    return (
      <HStack gap={"8"} className={'mapWrapper'}>
        <Skeleton active={true}/>
      </HStack>
    )
  }

  if (error && !isLoading && !chats) {
    return (
      <HStack gap={"8"} className={'mapWrapper'}>
        При выполнении запроса возникла ошибка.
        Попробуйте перезагрузить страницу или открыть карточку повторно.
      </HStack>
    )
  }

  if (!chats?.length) {
    return (
      <HStack gap={"8"} className={'mapWrapper'}>
        Нет активных чатов
      </HStack>
    )
  }

  const metadata = activeChatData.metadata

  return (
    <HStack align='stretch'>
      <Menu
        style={{minWidth: 150, maxWidth: 300}}
        selectedKeys={activeChatId ? [activeChatId] : []}
        onClick={changeChatHandler}
      >
        {chats && chats.map(item =>
          <Menu.Item key={item?.chat_id}>
            {item.name}
            <BadgeBox>
              <Badge count={item.count_not_read} offset={[10, 0]}/>
            </BadgeBox>
          </Menu.Item>
        )}
      </Menu>
      <ChatBox>
        {metadata && (
          <MetaBox>
            {metadata.itemUrl && (
              <a href={metadata.itemUrl} target='_blank' rel='noopener noreferrer'>
                <LinkOutlined/> Открыть объявление
              </a>
            )}
            {metadata.chatUrl && (
              <Button
                type='primary'
                size='small'
                icon={<MessageOutlined />}
                href={metadata.chatUrl}
                target='_blank'
              >
                Чат на Авито
              </Button>
            )}
          </MetaBox>
        )}
        <MessageBox data={activeChatData} metadata={activeChatData?.metadata}/>
        <ReplyBox id={id} chat_id={activeChatId} card_type="hr"/>
      </ChatBox>
    </HStack>
  )
})
